import { OnInit } from '@angular/core';
import { Component} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';

@Component({
  selector: 'app-pdfhelp',
  templateUrl: './pdfhelp.component.html',
  styleUrls: ['./pdfhelp.component.css']
})
export class PdfhelpComponent implements OnInit {

  constructor(private commonDataService: CommonDataService, private graphQL: GraphqlService, private domSanitizer: DomSanitizer) {

  }
  pdfsrc
  ngOnInit() {
    var pdfname = this.commonDataService.pdfName.getValue();
    if (pdfname != "") {
      let url = window.location.origin + '/layoutComponents/getPdf?isSitesBucket=' + true + '&fileName=' + pdfname
      this.pdfsrc = url;

      //this.graphQL.getPDF(true, pdfname).subscribe(data => { if (data != "") { console.log(data); this.pdfsrc = data } })
   
    }
  }
}

